import { EChecklistTaskStatus, TaskCategories } from 'common/contracts';
import { ISetupChecklistCategory, ISetupChecklistTask } from 'pages/Layout/SetupChecklist/types';

import { Observable } from './observable';

class SetupChecklistStateService {
  readonly isExpanded = new Observable<boolean>(false);
  readonly isVerifyBusinessModalOpen = new Observable<boolean>(false);
  readonly isSendAgreementModalOpen = new Observable<boolean>(false);
  readonly categories = new Observable<ISetupChecklistCategory[]>([]);
  readonly tasks = new Observable<ISetupChecklistTask[]>([]);
  readonly selectedCategory = new Observable<
    (typeof TaskCategories)[keyof typeof TaskCategories] | ''
  >('');
  readonly shouldWidgetBeShown = new Observable<boolean>(false);

  clear = () => {
    this.isExpanded.set(false);
    this.isVerifyBusinessModalOpen.set(false);
    this.isSendAgreementModalOpen.set(false);
    this.categories.set([]);
    this.tasks.set([]);
    this.selectedCategory.set('');
    this.shouldWidgetBeShown.set(false);
  };

  setIsExpanded = (expanded: boolean) => this.isExpanded.set(expanded);
  setIsVerifyBusinessModalOpen = (open: boolean) =>
    this.isVerifyBusinessModalOpen.set(open);
  setIsSendAgreementModalOpen = (open: boolean) =>
    this.isSendAgreementModalOpen.set(open);
  setCategories = (cat: ISetupChecklistCategory[]) => this.categories.set(cat);
  setTasks = (tasks: ISetupChecklistTask[]) => this.tasks.set(tasks);
  setSelectedCategory = (
    cat: (typeof TaskCategories)[keyof typeof TaskCategories] | ''
  ) => this.selectedCategory.set(cat);
  setShouldWidgetBeShown = (shouldShow: boolean) => this.shouldWidgetBeShown.set(shouldShow);

  toggleChecklistExpandedState = (
    fetchTasks: () => void,
    forceState?: boolean
  ) => {
    const newState =
      forceState !== undefined ? forceState : !this.isExpanded.get();
    setupChecklistStateService.setIsExpanded(newState);

    fetchTasks();

    if (newState) {
      this.resetSelectedCategory();
    }
  };

  resetSelectedCategory = () => {
    const selectedCategoryTitle = this.categories
      .get()
      ?.find(({ tasks }) =>
        tasks.find(({ status }) => status === EChecklistTaskStatus.OPEN)
      )?.title;

    this.setSelectedCategory(selectedCategoryTitle || '');
  };
}

export const setupChecklistStateService = new SetupChecklistStateService();
